export function selectionsTransformation({ selections, sliders }) {
  const selectionsScores = handleScoresCalculation({ selections, sliders });
  const maxScore = Math.max(...selectionsScores);
  const minScore = Math.min(...selectionsScores);
  const range = maxScore - minScore;
  let selectionsPercentages = [];
  if (range > 0) {
    selectionsPercentages = handlePercentagesCalculation({ selectionsScores, minScore, range });
  }

  if (range <= 0) {
    selectionsPercentages = selectionsScores.map(() => 0);
  }
  return addPercentageProperty({ selections, selectionsPercentages });
}

function handleScoresCalculation({ selections, sliders }) {
  try {
    return selections.map(selection => {
      let score = 0;
      sliders.map(slideData => {
        const { key, defaultValue: slideValue } = slideData;
        const selectionAttributeValue = selection.predictorData[key];
        const product = selectionAttributeValue * slideValue;
        score += product;
      });
      return score;
    });
  } catch (error) {
    console.log(error);
  }
}

function handlePercentagesCalculation({ selectionsScores, minScore, range }) {
  return selectionsScores.map(score => (score - minScore) / range);
}

function addPercentageProperty({ selections, selectionsPercentages }) {
  return selections.map((selection, index) => {
    return {
      ...selection,
      percentage: selectionsPercentages[index],
      index,
    };
  });
}

export default { selectionsTransformation };
